export enum WebsiteNavigation {
    HOME = 'home',
    PROGRAM = 'program',
    SPECIALS = 'specials',
    DEALS = 'deals',
    /** @deprecated Replaced with `SHOPS`. Kept so existing visibility config keeps working. */
    VOUCHERS = 'vouchers',
    SHOPS = 'shops',
    ANNOUNCEMENTS = 'announcements',
    BAR = 'bar',
    INFO = 'info'
}
